import { render, staticRenderFns } from "./facture.vue?vue&type=template&id=1d414d0c&scoped=true"
import script from "./facture.vue?vue&type=script&lang=js"
export * from "./facture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d414d0c",
  null
  
)

export default component.exports